module.exports = __webpack_public_path__ + "static/img/housegraphroof-test.7691587.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/housegraphroof-test.png
// module id = dN0q
// module chunks = 73